import { useTranslation } from 'react-i18next';
import { getStorefrontOrigin } from '../exports/Cookies';
import useStorefront from './useStorefront';

export interface IStorefrontRouter {
  navigate: (href: string) => void;
}

const useStorefrontRouter = (): IStorefrontRouter => {
  const { i18n } = useTranslation();
  const { translationsEnabled } = useStorefront();
  const locale = translationsEnabled && i18n.language !== 'en' ? `/${i18n.language}` : '';

  const navigate = (href: string): void => {
    window.location.href = `${getStorefrontOrigin()}${locale}${href}`;
  };

  return {
    navigate,
  };
};

export default useStorefrontRouter;
